
/* eslint-disable max-len */
import React, { useContext, useState, useEffect } from 'react'
import AnimatedList from '../../../components/Animation/AnimatedList'
import AnimatedButton from '../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { toggleRowSelection } from '../../../redux/MultiselectRows'
import { convertEpochToDateFormat } from '../../../CommonMethods/convertEpochToDateFormat'
import { organizationusersList } from '../../../slices/apiSlice'
import GlobalContext from '../../../components/Context/GloablContext'
import { setPatientSearch,resetPatientSearch } from '../../../redux/patientSearchSlice';
import { useUpdateMonitorPatientAlertPreferencesMutation } from '../../../slices/patientSlice'


const TableBodyPatient=({tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    fromPatientTab,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg})=>{
    const navigate=useNavigate()
    const auth=useSelector(state=>state?.auth)
    const {userType}=auth
    const dispatch=useDispatch()
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams,setSearchParams]=useSearchParams({})
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const {setIsSearchOpen, isSearchOpen, setToastmessage, setToastErrorMessage} = useContext(GlobalContext);
    const [updateMonitorPatientAlertPreferences] = useUpdateMonitorPatientAlertPreferencesMutation()

    // Initialize toggle states from tableData
    // Check for new API fields first, then fallback to old field names for backward compatibility
    const getSmsAlertValue = (data) => {
        if (data?.sms_alert !== undefined) {
            return data.sms_alert === true || data.sms_alert === "true" || data.sms_alert === 1
        }
        // Fallback to old field names (inverted logic)
        return data?.block_sms === false || data?.block_sms === "false"
    }
    
    const getEmailAlertValue = (data) => {
        if (data?.email_alert !== undefined) {
            return data.email_alert === true || data.email_alert === "true" || data.email_alert === 1
        }
        // Fallback to old field names (inverted logic)
        return data?.block_email === false || data?.block_email === "false"
    }
    
    const getMissedReadingValue = (data) => {
        if (data?.missed_reading_alert !== undefined) {
            return data.missed_reading_alert === true || data.missed_reading_alert === "true" || data.missed_reading_alert === 1
        }
        // Fallback to old field names
        return data?.include_missed_readings === true || data?.include_missed_readings === "true" || data?.include_missed_readings === 1
    }

    const [smsAlert, setSmsAlert] = useState(getSmsAlertValue(tableData))
    const [emailAlert, setEmailAlert] = useState(getEmailAlertValue(tableData))
    const [missedReading, setMissedReading] = useState(getMissedReadingValue(tableData))
    const [smsLoading, setSmsLoading] = useState(false)
    const [emailLoading, setEmailLoading] = useState(false)
    const [missedReadingLoading, setMissedReadingLoading] = useState(false)

    // Update states when tableData changes
    useEffect(() => {
        setSmsAlert(getSmsAlertValue(tableData))
        setEmailAlert(getEmailAlertValue(tableData))
        setMissedReading(getMissedReadingValue(tableData))
    }, [tableData])

    const handleSmsAlertToggle = async (e) => {
        e.stopPropagation()
        if (smsLoading) return // Prevent action if already loading
        const newValue = !smsAlert
        setSmsAlert(newValue)
        setSmsLoading(true)
        
        try {
            const body = {
                sms_alert: newValue
            }
            const response = await updateMonitorPatientAlertPreferences({ 
                patient_id: tableData?.patient_id, 
                body 
            })
            if (response?.error) {
                setSmsAlert(!newValue) // Revert on error
                setToastErrorMessage(response?.error?.data?.message || 'Failed to update SMS alert preference')
            } else {
                setToastmessage('SMS alert preference updated successfully')
            }
        } catch (error) {
            setSmsAlert(!newValue) // Revert on error
            setToastErrorMessage('Failed to update SMS alert preference')
        } finally {
            setSmsLoading(false)
        }
    }

    const handleEmailAlertToggle = async (e) => {
        e.stopPropagation()
        if (emailLoading) return // Prevent action if already loading
        const newValue = !emailAlert
        setEmailAlert(newValue)
        setEmailLoading(true)
        
        try {
            const body = {
                email_alert: newValue
            }
            const response = await updateMonitorPatientAlertPreferences({ 
                patient_id: tableData?.patient_id, 
                body 
            })
            if (response?.error) {
                setEmailAlert(!newValue) // Revert on error
                setToastErrorMessage(response?.error?.data?.message || 'Failed to update Email alert preference')
            } else {
                setToastmessage('Email alert preference updated successfully')
            }
        } catch (error) {
            setEmailAlert(!newValue) // Revert on error
            setToastErrorMessage('Failed to update Email alert preference')
        } finally {
            setEmailLoading(false)
        }
    }

    const handleMissedReadingToggle = async (e) => {
        e.stopPropagation()
        if (missedReadingLoading) return // Prevent action if already loading
        const newValue = !missedReading
        setMissedReading(newValue)
        setMissedReadingLoading(true)
        
        try {
            const body = {
                missed_reading_alert: newValue
            }
            const response = await updateMonitorPatientAlertPreferences({ 
                patient_id: tableData?.patient_id, 
                body 
            })
            if (response?.error) {
                setMissedReading(!newValue) // Revert on error
                setToastErrorMessage(response?.error?.data?.message || 'Failed to update Missed Reading preference')
            } else {
                setToastmessage('Missed Reading preference updated successfully')
            }
        } catch (error) {
            setMissedReading(!newValue) // Revert on error
            setToastErrorMessage('Failed to update Missed Reading preference')
        } finally {
            setMissedReadingLoading(false)
        }
    }

    // Extract navigation logic to avoid duplication
    const navigateToPatient = () => {
        dispatch(organizationusersList.util.resetApiState())
        setIsSearchOpen(false)      
        dispatch(resetPatientSearch());          
        fromPatientTab==='true'
            ? navigate(`/manage-patients/provider-list/${tableData._id}/${tableData.patient_id}`, {
                state: {
                    "limit": searchParams.get("limit"),
                    "page_number": searchParams.get("page_number"),
                    'user_id': tableData?.patient_id,
                    'id': tableData?._id
                }
            })
            : navigate(`/manage-dashboard/provider-list/${tableData._id}/${tableData.patient_id}`, {
                state: {
                    "limit": searchParams.get("limit"),
                    "page_number": searchParams.get("page_number"),
                    'user_id': tableData?.patient_id,
                    'id': tableData?._id
                }
            })
    }

    const handleViewClick = (e) => {
        e.stopPropagation()
        navigateToPatient()
    }

    const handleRowDoubleClick = (e) => {
        if (e.target.classList.contains('prevent-click')) {
            return;
        } else {
            navigateToPatient()
        }
    }
  
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)
    return(
        <>
            <AnimatedList
                id={tableData.patient_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleDoubleClick={handleRowDoubleClick}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.user_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.first_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.middle_name===""||tableData?.middle_name===undefined?"-":tableData?.middle_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.last_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.date_of_birth}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.age}</td>
                        <td className="px-[18px] py-2">
                            <div className="flex items-center justify-start">
                                <img loading="lazy" decoding="async" src={`${tableData?.status==="active"?"/images/active_list_img.svg":'/images/inactive_list_img.svg'}`} alt="icon" />
                                <span className="text-sm text-start font-normal text-[#031624] pl-2">{tableData?.status==="active"?"Active":"Inactive"}</span>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] prevent-click">
                            <div className="status custom-toggle flex items-center justify-start">
                                <label className={`switch monitor ${smsLoading ? 'pointer-events-none opacity-60' : ''}`}>
                                    <input
                                        type="checkbox"
                                        onChange={handleSmsAlertToggle}
                                        checked={smsAlert}
                                        disabled={smsLoading}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] prevent-click">
                            <div className="status custom-toggle flex items-center justify-start">
                                <label className={`switch monitor ${emailLoading ? 'pointer-events-none opacity-60' : ''}`}>
                                    <input
                                        type="checkbox"
                                        onChange={handleEmailAlertToggle}
                                        checked={emailAlert}
                                        disabled={emailLoading}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] prevent-click">
                            <div className="status custom-toggle flex items-center justify-start">
                                <label className={`switch monitor ${missedReadingLoading ? 'pointer-events-none opacity-60' : ''}`}>
                                    <input
                                        type="checkbox"
                                        onChange={handleMissedReadingToggle}
                                        checked={missedReading}
                                        disabled={missedReadingLoading}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.organization_name===undefined||tableData?.organization_name===''?"-":tableData?.organization_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.subdivision_name===undefined||tableData?.subdivision_name===''?"-":tableData?.subdivision_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.primary_identifier===""||tableData?.primary_identifier===undefined?"-":tableData?.primary_identifier}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.secondary_identifier===""||tableData?.secondary_identifier===undefined?"-":tableData?.secondary_identifier}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.email_address===""||tableData?.email_address===undefined?"-":tableData?.email_address}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.map((item)=>item.id).includes(tableData?.patient_id)?'bg-[#F8EEF1]':'bg-white '} last-td`}>
                            <button  
                                id="View"
                                onClick={handleViewClick}
                                className="py-1 px-4 rounded-[6px] disabled border border-[#972E4C] text-sm leading-normal font-semibold text-[#972E4C] hover:bg-[#972E4C] hover:text-white transition-colors" 
                            >View</button>
                        </td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBodyPatient
